<script setup>
const props = defineProps({
    value: [Number, String]
})

const formatNumber = (val) => {
    if (val === null || val === undefined) return ''

    // Check if the number was a float, by searching for a decimal, and if so do not format it.
    // This is to work around a number formatting issue for numbers with decimal places. For example,
    // PG's carbonCalculation, set with a step of 0.00001 was being rounded to zero.
    return (val + '').includes('.') ? val : new Intl.NumberFormat().format(val)
}
</script>

<template>
    <span>{{ formatNumber(value) }}</span>
</template>